import { useMemo, useState } from 'react';

import { makeCountriesList } from '../helpers/country.helper';
import { NormalizedFlagsProps } from '../phone-field.types';

export function usePhoneFieldState(props: NormalizedFlagsProps) {
  const { defaultCountryCode, selectableCountries, flagMode, highlights } = props;
  const [selectedCountry, setSelectedCountry] = useState(defaultCountryCode);

  const items = useMemo(
    () =>
      makeCountriesList({
        defaultCountryCode,
        selectableCountries,
        flagMode,
        highlights,
      }),
    [defaultCountryCode, flagMode, highlights, selectableCountries],
  );

  return {
    selectedCountry,
    setSelectedCountry,
    selectableCountries,
    items,
  };
}
